import { useCallback, useRef, useState } from 'react';

export const useTextOverflow = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  const checkOverflow = useCallback(() => {
    const element = ref.current;

    if (element) {
      setIsOverflowed(element.scrollWidth > element.clientWidth);
    }
  }, []);

  return { ref, checkOverflow, isOverflowed };
};
